import Service from '../helpers/service';
import { fetchIslRewards } from "../actions/isl_rewards_action";
import {
  fetchIslRewardsMeta
} from "../actions/isl_rewards_meta_action";
import Helping from "../helpers/Helping";
import { API_URL } from "../config/urls";
import { GET_TEAMS } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}

export const setItemError = (callback) => {

  updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type, brandId = "", categoryId = "", typeId = "") => {
  return dispatch => {
    return trackPromise(
      Service.postCall(API_URL.ADMIN_API + GET_TEAMS, {
        page, limit, sorting, sort_type, action: "reward-listing"
      })
        .then(response => {
          let total = response.data.payload.count;

          dispatch(fetchIslRewards(response.data.payload.rows));
          dispatch(
            fetchIslRewardsMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: total,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);
          dispatch(fetchIslRewards([]));
          dispatch(
            fetchIslRewardsMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: 0,
              no_Of_pages: page
            })
          );
          Helping.redirectToLogin(error);
          return updateCallback({
            ...Helping.setNetworkRequestError(error, "fetching rewards")
          })
        })
    )
  };
};

